'use client';

import { useEffect,useState } from 'react';
import Request from './requestPermission'; 
import { useSelector } from 'react-redux';
import axios from 'axios'
import {KeyUri} from '../key'

const NotificationInit = () => {
  const { token, user } = useSelector((state) => state.userauth); 
  const [retrievedData] = useState(() =>
    JSON.parse(localStorage.getItem("userID"))
  );
  useEffect(() => {
    const initFCM = async () => {
      try {
        const token = await Request();
        if (token) {
      
          await axios.post(
            `${KeyUri.BACKEND_URI}/createfcm`,
            {
              token: token,
              user: retrievedData,
            },
          );

        
        } else {
          console.warn(' FCM Token not retrieved');
        }
      } catch (err) {
        console.error(' Error initializing FCM:', err);
      }
    };

    initFCM();
    if (token && user) {
      initFCM();
    }
  }, [token, user]);

  return null;
};

export default NotificationInit;
